import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Button from "../Button";

const Plan = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const { isShowHeader = true, handleChangeSlidePlan = () => {} } = props;
  const [isMonthly, setIsMonthly] = useState(true);

  const allPlans = [
    // {
    //   key: "7-Day Trial",
    //   pricePerMonth: 0,
    //   description: "เหมาะกับการเริ่มต้นใช้งาน",
    //   feature: [
    //     { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ", limit: 30 },
    //     { title: "จำนวนรายการสินค้า", limit: 50 },
    //     { title: "จำนวนแอดมิน", limit: 2 },
    //     { title: "จำนวนลูกค้าสูงสุด", limit: 5000 },
    //     { title: "ระบบรายงานการขาย" },
    //     { title: "ระบบรายงานข้อมูลลูกค้า" },
    //     { title: "รายงานพัสดุที่ต้องจัดส่ง" },
    //   ],
    // },
    {
      key: "Starter",
      pricePerMonth: 1590,
      hasDiscount: true,
      fullPrice: 1590,
      pricePerYear: 1329,
      prefixPrice: "Starts",
      description: "เหมาะกับธุรกิจเริ่มต้นขายสินค้า",
      feature: [
        { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ", limit: 30 },
        { title: "จำนวนรายการสินค้า", limit: 20 },
        { title: "จำนวนแอดมิน", limit: 2 },
        { title: "จำนวนลูกค้าสูงสุด", limit: 1000 },
        { title: "ระบบรายงานการขาย" },
        { title: "ระบบรายงานข้อมูลลูกค้า" },
        { title: "รายงานพัสดุที่ต้องจัดส่ง" },
      ],
    },
    {
      key: "Small",
      pricePerMonth: 2590,
      hasDiscount: true,
      fullPrice: 2590,
      pricePerYear: 2159,
      prefixPrice: "Small",
      description: "เหมาะกับธุรกิจขนาดเล็ก",
      feature: [
        { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ", limit: 100 },
        { title: "จำนวนรายการสินค้า", limit: 50 },
        { title: "จำนวนแอดมิน", limit: 2 },
        { title: "จำนวนลูกค้าสูงสุด", limit: 3000 },
        { title: "ระบบรายงานการขาย" },
        { title: "ระบบรายงานข้อมูลลูกค้า" },
        { title: "รายงานพัสดุที่ต้องจัดส่ง" },
      ],
    },
    {
      key: "Medium",
      pricePerMonth: 3990,
      hasDiscount: true,
      fullPrice: 3990,
      pricePerYear: 3299,
      prefixPrice: "Medium",
      description: "เหมาะกับธุรกิจขนาดกลางถึงใหญ่",
      feature: [
        { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ", limit: 100 },
        { title: "จำนวนรายการสินค้า", limit: 150 },
        { title: "จำนวนแอดมิน", limit: 2 },
        { title: "จำนวนลูกค้าสูงสุด", limit: 5000 },
        { title: "ระบบรายงานการขาย" },
        { title: "ระบบรายงานข้อมูลลูกค้า" },
        { title: "รายงานพัสดุที่ต้องจัดส่ง" },
      ],
    },
    {
      key: "Large",
      pricePerMonth: 5990,
      hasDiscount: true,
      fullPrice: 5990,
      pricePerYear: 4899,
      prefixPrice: "Large",
      description: "เหมาะกับธุรกิจขนาดใหญ่",
      feature: [
        { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ", limit: 200 },
        { title: "จำนวนรายการสินค้า", limit: 500 },
        { title: "จำนวนแอดมิน", limit: 10 },
        { title: "จำนวนลูกค้าสูงสุด", limit: 10000 },
        { title: "ระบบรายงานการขาย" },
        { title: "ระบบรายงานข้อมูลลูกค้า" },
        { title: "รายงานพัสดุที่ต้องจัดส่ง" },
      ],
    },
    {
      key: "Custom",
      pricePerMonth: "-1",
      description: "สามารถออกแบบแพลนได้ตามต้องการ",
      feature: [
        { title: "สอน AI ตอบคำถามเฉพาะธุรกิจ" },
        { title: "จำนวนลูกค้าและสินค้าแบบกำหนดเอง" },
        { title: "ระบบรายงานการขายและลูกค้า" },
        { title: "ระบบรับชำระเงินออนไลน์อื่น ๆ" },
        { title: "เชื่อมต่อระบบ API" },
        { title: "เชื่อมต่อระบบ SAP" },
      ],
    },
  ];

  const settings = {
    afterChange: (current) => handleChangeSlidePlan(current),
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1520,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <main className="mb-4">
      <div className={isShowHeader ? "mb-16" : "mb-8"}>
        {isShowHeader && (
          <div className="text-center mb-10">
            <h1 className="mb-4 text-2xl font-normal md:text-3xl lg:text-4xl text-black">
              เลือกแพลนที่ใช่ให้กับธุรกิจของคุณ
            </h1>
            <p className="font-normal text-black">
              เรามีแพลนให้เลือกสำหรับธุรกิจทุกขนาด
            </p>
            <p className="font-normal text-black">
              เพื่อให้คุณมั่นใจว่าจะใช้งานระบบของเราได้คุ้มค่าที่สุด
            </p>
          </div>
        )}

        {/* Plan switch  */}
        <div className="flex flex-row items-center justify-center space-x-4">
          <span
            className={`${
              isShowHeader ? "text-black" : ""
            } font-medium cursor-pointer pl-1`}
            onClick={() => setIsMonthly(true)}
          >
            รายเดือน
          </span>
          <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
            <input
              type="checkbox"
              name="toggle"
              id="toggle"
              className="toggle-checkbox absolute block w-6 h-6 rounded-full border-4 appearance-none cursor-pointer bg-black"
              checked={!isMonthly}
              onChange={() => setIsMonthly(!isMonthly)}
            />
            <label
              htmlFor="toggle"
              className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
            ></label>
          </div>
          <span
            className={`${
              isShowHeader ? "text-black" : ""
            } font-medium cursor-pointer pr-1`}
            onClick={() => setIsMonthly(false)}
          >
            รายปี
          </span>
          <span
            className="px-2 py-1 text-white"
            style={{
              background: "#121419",
              borderRadius: "4px",
              fontSize: "14px",
            }}
          >
            FREE 2 MONTHS
          </span>
        </div>
      </div>

      {/* Plans  */}
      <div>
        <div
          style={{
            maxWidth: "1550px",
          }}
          className="mx-auto"
        >
          <Slider {...settings}>
            {allPlans.map((plan) => {
              return (
                <div key={plan.key}>
                  <div
                    style={{
                      minWidth: "280px",
                      maxWidth: "280px",
                      width: "280px",
                    }}
                    className="p-6 py-2 space-y-2 bg-white rounded-lg shadow-card mb-2 mx-auto"
                  >
                    {/* Price  */}
                    <div
                      className="flex-shrink-0 space-y-0 text-center mt-2"
                      style={{ minHeight: "170px", maxHeight: "170px" }}
                    >
                      <h2 className="text-4xl font-normal">{plan.key}</h2>
                      <p
                        className="text-sm"
                        style={{ height: 40, color: "#737D94" }}
                      >
                        {plan.description}
                      </p>

                      <p
                        className="text-4xl font-medium tracking-tight"
                        style={{
                          fontSize: 54,
                        }}
                      >
                        {plan.prefixPrice && (
                          <span
                            className="text-sm mr-3"
                            style={{ color: "#737D94" }}
                          >
                            {plan.prefixPrice}
                          </span>
                        )}
                        {plan.pricePerMonth > 0
                          ? isMonthly
                            ? plan.pricePerMonth
                            : plan.pricePerYear || 0
                          : plan.pricePerMonth == 0
                          ? "FREE"
                          : "Let’s Talk"}

                        {plan.pricePerMonth > 0 && (
                          <span
                            className="text-sm ml-2.5 w-full relative"
                            style={{
                              color: "#737D94",
                            }}
                          >
                            {plan.hasDiscount && !isMonthly && (
                              <span
                                className="strikethrough absolute w-full text-white rounded-sm"
                                style={{
                                  background: "#8778FF",
                                  fontSize: "12px",
                                }}
                              >
                                {plan.fullPrice}
                              </span>
                            )}
                            {isMonthly || plan.hasDiscount
                              ? " / mo"
                              : " / year"}
                          </span>
                        )}
                      </p>
                    </div>

                    {/* Features  */}
                    <ul className="flex-1 space-y-3 pb-4">
                      <div style={{ height: "194px" }} className="mb-4">
                        {plan.feature.map((item) => {
                          return (
                            <li
                              className="flex items-start mb-2.5"
                              key={item.title}
                            >
                              {!item.disabled ? (
                                <>
                                  <svg
                                    width="13"
                                    height="19"
                                    viewBox="0 0 13 9"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10.6488 0.61573C11.058 0.206541 11.7214 0.206541 12.1306 0.61573C12.5398 1.02492 12.5398 1.68835 12.1306 2.09753L5.84384 8.3843C5.43465 8.79349 4.77123 8.79349 4.36204 8.3843L0.869392 4.89165C0.460203 4.48246 0.460203 3.81904 0.869392 3.40985C1.27858 3.00066 1.94201 3.00066 2.3512 3.40985L5.10294 6.16159L10.6488 0.61573Z"
                                      fill="#00C566"
                                    />
                                  </svg>
                                </>
                              ) : (
                                <svg
                                  width="11"
                                  height="19"
                                  viewBox="0 0 11 11"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9.62046 2.30784L9.62057 2.30773C9.74351 2.18463 9.81254 2.01776 9.81248 1.84378C9.81243 1.66981 9.7433 1.50297 9.62028 1.37995C9.49726 1.25693 9.33042 1.1878 9.15645 1.18774C8.98247 1.18769 8.8156 1.25672 8.6925 1.37966L8.69239 1.37977L5.50017 4.57199L2.30796 1.37977L2.30784 1.37966C2.18475 1.25672 2.01787 1.18769 1.8439 1.18774C1.66992 1.1878 1.50309 1.25693 1.38007 1.37995C1.25705 1.50297 1.18791 1.66981 1.18786 1.84378C1.18781 2.01776 1.25684 2.18463 1.37978 2.30773L1.37989 2.30784L4.57211 5.50006L1.38 8.69216C1.37996 8.6922 1.37993 8.69223 1.37989 8.69227C1.31894 8.75317 1.27058 8.82548 1.23757 8.90507C1.20454 8.9847 1.18753 9.07007 1.1875 9.15628C1.18747 9.24249 1.20443 9.32787 1.23741 9.40752C1.27039 9.48718 1.31875 9.55956 1.37971 9.62052C1.44067 9.68148 1.51305 9.72983 1.5927 9.76281C1.67236 9.79579 1.75773 9.81275 1.84395 9.81273C1.93016 9.8127 2.01553 9.79568 2.09516 9.76266C2.1748 9.72962 2.24714 9.68123 2.30807 9.62023L5.50017 6.42812L8.69239 9.62034L8.6925 9.62045C8.8156 9.74339 8.98247 9.81242 9.15645 9.81237C9.33042 9.81231 9.49726 9.74318 9.62028 9.62016C9.7433 9.49714 9.81243 9.3303 9.81248 9.15633C9.81254 8.98236 9.74351 8.81548 9.62057 8.69238L9.62046 8.69227L6.42824 5.50006L9.62046 2.30784Z"
                                    fill="#D7D9E1"
                                    stroke="#D7D9E1"
                                    strokeWidth="0.5"
                                  />
                                </svg>
                              )}
                              <div
                                className="flex justify-between w-full"
                                style={{ fontSize: 12 }}
                              >
                                <div
                                  className={`ml-3 font-small`}
                                  style={{
                                    color: !item.disabled
                                      ? "#737D94"
                                      : "#D7D9E1",
                                  }}
                                >
                                  {item.title}
                                </div>
                                {item.limit && (
                                  <div className="ml-3 text-gray-800 font-small">
                                    {item.limit.toLocaleString("th-TH", {})}
                                  </div>
                                )}
                              </div>
                            </li>
                          );
                        })}
                      </div>

                      {/* Button  */}
                      <div className="flex-shrink-0 pt-2">
                        <a
                          href={
                            plan.pricePerMonth >= 0
                              ? "https://console.1convo.ai/register"
                              : "/contact"
                          }
                        >
                          <Button
                            className="inline-flex choose-plan-button"
                            variant="dark"
                            size="small"
                          >
                            {plan.pricePerMonth >= 0
                              ? "สมัครใช้งาน"
                              : "ติดต่อเรา"}
                          </Button>
                        </a>
                      </div>
                    </ul>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </main>
  );
};

export default Plan;
